module.exports = __webpack_public_path__ + "static/img/swiper1.bfa9778c.png";